module.exports = __webpack_public_path__ + "static/audi-ffbd5e72b48efd836be1980a26327116.png";